import React, { useEffect } from 'react';
import { animateScroll as scroll } from 'react-scroll';
import './Scrollup.css';

const ScrollUp = () => {
    useEffect(() => {
        const toggleVisibility = () => {
            const scrollUp = document.querySelector(".scrollup");
            if (window.scrollY >= 560) {
                scrollUp.classList.add("show__scroll");
            } else {
                scrollUp.classList.remove("show__scroll");
            }
        };

        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    return (
        <a onClick={() => scroll.scrollToTop()} className="scrollup">
            <i className="uil uil-arrow-up scrollup__icon"></i>
        </a>
    );
};

export default ScrollUp;
